// import { useState, useEffect } from "react";
// import { useParams, useNavigate, Link } from 'react-router';
// import Cookies from 'js-cookie';
// import { downloadComplaintAttachment, getSellerComplaint, requestComplaintReview, submitComplaintResponse, uploadComplaintAttachments } from '../../../services/customerComplaint.service';
// import {
//   ArrowLeft, Clock, CheckCircle, XCircle, AlertCircle, MessageSquare,
//   Upload, Download, FileText, Image as ImageIcon, Send, Paperclip,
//   User, Shield, Phone, X, ExternalLink, AlertTriangle
// } from 'lucide-react';

// const STATUS_CONFIG: Record<string, { label: string; color: string; bg: string }> = {
//   submitted: { label: 'Submitted', color: 'text-[#1E6DFF]', bg: 'bg-[#1E6DFF]/10' },
//   under_review: { label: 'Under Review', color: 'text-[#F59E0B]', bg: 'bg-[#F59E0B]/10' },
//   awaiting_response: { label: 'Awaiting Response', color: 'text-[#8B5CF6]', bg: 'bg-[#8B5CF6]/10' },
//   resolved: { label: 'Resolved', color: 'text-[#22C55E]', bg: 'bg-[#22C55E]/10' },
//   rejected: { label: 'Rejected', color: 'text-[#EF4444]', bg: 'bg-[#EF4444]/10' },
//   closed: { label: 'Closed', color: 'text-[#717182]', bg: 'bg-[#717182]/10' },
// };

// const MOCK = {
//   id: 'CMP-482910',
//   date: 'June 3, 2026',
//   status: 'awaiting_response',
//   category: 'Fraudulent Listing',
//   subject: 'Vehicle photos do not match actual condition',
//   description: 'The listing shows a 2022 Mercedes C-Class in excellent condition with no accident history. However, upon inspection, the vehicle had clear signs of significant body damage on the rear panel and the odometer reading was inconsistent with the stated mileage.',
//   buyer: { name: 'Karim Alaoui', id: 'USR-4892', joined: 'March 2025', verified: true },
//   vehicle: { title: 'Mercedes-Benz C-Class AMG 2022', id: 'LST-001', price: '485,000 MAD' },
//   evidence: [
//     { name: 'photo_front.jpg', type: 'image', size: '1.2 MB' },
//     { name: 'photo_rear_damage.jpg', type: 'image', size: '980 KB' },
//     { name: 'inspection_report.pdf', type: 'pdf', size: '2.1 MB' },
//   ],
//   timeline: [
//     { event: 'Complaint Filed', date: 'Jun 3, 2026 · 10:14 AM', actor: 'Karim A.', role: 'buyer', note: 'Buyer filed a complaint citing vehicle condition mismatch.' },
//     { event: 'Admin Review Started', date: 'Jun 3, 2026 · 2:30 PM', actor: 'MORROCARS Team', role: 'admin', note: 'Your listing is under review. Please respond within 72 hours.' },
//     { event: 'Response Requested', date: 'Jun 4, 2026 · 9:00 AM', actor: 'System', role: 'system', note: 'Seller response required to proceed with investigation.' },
//   ],
// };

// function SellerComplaintDetailSkeleton() {
//   return (
//     <div className="p-4 md:p-8 max-w-5xl">
//       {/* Header */}
//       <div className="flex items-center gap-3 mb-6">
//         <Skeleton className="w-10 h-10 rounded-xl" />

//         <div className="flex-1 space-y-3">
//           <Skeleton className="h-7 w-64" />
//           <Skeleton className="h-4 w-40" />
//         </div>

//         <Skeleton className="w-28 h-8 rounded-full" />
//       </div>

//       <div className="grid grid-cols-1 lg:grid-cols-3 gap-6">
//         {/* Left */}
//         <div className="lg:col-span-2 space-y-5">

//           {/* Complaint */}
//           <div className="bg-white rounded-2xl border border-[#E5E7EB] p-6">
//             <Skeleton className="h-6 w-72 mb-4" />
//             <Skeleton className="h-4 w-full mb-2" />
//             <Skeleton className="h-4 w-full mb-2" />
//             <Skeleton className="h-4 w-5/6" />
//           </div>

//           {/* Evidence */}
//           <div className="bg-white rounded-2xl border border-[#E5E7EB] p-6">
//             <Skeleton className="h-6 w-48 mb-5" />

//             {[1,2,3].map((i)=>(
//               <div key={i} className="flex items-center gap-3 mb-3">
//                 <Skeleton className="w-10 h-10 rounded-lg" />

//                 <div className="flex-1">
//                   <Skeleton className="h-4 w-48 mb-2" />
//                   <Skeleton className="h-3 w-20" />
//                 </div>

//                 <Skeleton className="w-8 h-8 rounded-lg" />
//               </div>
//             ))}
//           </div>

//           {/* Timeline */}
//           <div className="bg-white rounded-2xl border border-[#E5E7EB] p-6">
//             <Skeleton className="h-6 w-36 mb-5" />

//             {[1,2,3].map((i)=>(
//               <div key={i} className="flex gap-3 mb-6">
//                 <Skeleton className="w-8 h-8 rounded-full" />

//                 <div className="flex-1">
//                   <Skeleton className="h-24 rounded-xl w-full" />
//                 </div>
//               </div>
//             ))}
//           </div>

//           {/* Response */}
//           <div className="bg-white rounded-2xl border border-[#E5E7EB] p-6">
//             <Skeleton className="h-6 w-52 mb-2" />
//             <Skeleton className="h-4 w-80 mb-5" />

//             <Skeleton className="h-36 rounded-xl mb-4" />

//             <div className="flex gap-3">
//               <Skeleton className="h-11 w-44 rounded-xl" />
//               <Skeleton className="h-11 w-40 rounded-xl" />
//             </div>
//           </div>
//         </div>

//         {/* Right Sidebar */}
//         <div className="space-y-5">

//           {[1,2,3].map((card)=>(
//             <div
//               key={card}
//               className="bg-white rounded-2xl border border-[#E5E7EB] p-5"
//             >
//               <Skeleton className="h-5 w-32 mb-4" />

//               <Skeleton className="w-12 h-12 rounded-full mb-4" />

//               <Skeleton className="h-4 w-40 mb-2" />
//               <Skeleton className="h-4 w-28 mb-5" />

//               <Skeleton className="h-10 w-full rounded-xl" />
//             </div>
//           ))}
//         </div>
//       </div>
//     </div>
//   );
// }

// const ROLE_STYLES: Record<string, string> = {
//   buyer: 'bg-[#1E6DFF]/10 text-[#1E6DFF]',
//   admin: 'bg-[#8B5CF6]/10 text-[#8B5CF6]',
//   system: 'bg-[#717182]/10 text-[#717182]',
//   seller: 'bg-[#22C55E]/10 text-[#22C55E]',
// };
// const formatDate = (value: string) => new Intl.DateTimeFormat('en-US', { month: 'short', day: 'numeric', year: 'numeric' }).format(new Date(value));

// const Skeleton = ({
//   className = "",
// }: {
//   className?: string;
// }) => (
//   <div
//     className={`animate-pulse rounded-lg bg-gray-200 ${className}`}
//   />
// );

// export function SellerComplaintDetail() {
//   const { id } = useParams();
//   const navigate = useNavigate();
//   const [complaint, setComplaint] = useState<any>(null);

//   const [response, setResponse] = useState('');
//   const [responseError, setResponseError] = useState('');
//   const [sending, setSending] = useState(false);
//   const [sent, setSent] = useState(false);
//   const [responses, setResponses] = useState<{ text: string; date: string }[]>([]);
//   const [showEscalateModal, setShowEscalateModal] = useState(false);
//   const [loading, setLoading] = useState(true);
//   const [loadError, setLoadError] = useState('');
//   const [reviewNote, setReviewNote] = useState('');
//   const [selectedFiles, setSelectedFiles] = useState<File[]>([]);
//   const complaintBasePath = Number(Cookies.get('customerType')) === 3 ? '/dealer/complaints' : '/dashboard/complaints';

//   const loadComplaint = async () => {
//   if (!id) return;
//     try {
//       setLoadError('');
//       const data = await getSellerComplaint(id);
//       setComplaint(data);
//       setResponses((data.responses || []).map((item: any) => ({ text: item.Message, date: new Date(item.CreatedOn).toLocaleString() })));
//     } catch (error: any) { setLoadError(error.response?.data?.message || 'Unable to load complaint'); }
//     finally { setLoading(false); }
//   };

//  useEffect(() => { void loadComplaint(); }, [id]);

//   const c = complaint && {
//     id: complaint.ComplaintNumber || complaint.id, date: formatDate(complaint.CreatedOn), status: complaint.Status,
//     category: complaint.Category, subject: complaint.Subject, description: complaint.Description, escalated: Boolean(complaint.EscalatedOn),
//     buyer: { name: complaint.buyer?.name || 'Buyer', id: complaint.buyer?.id || '', joined: complaint.buyer?.joined ? new Date(complaint.buyer.joined).toLocaleDateString() : '', verified: complaint.buyer?.verified },
//     vehicle: { title: complaint.vehicle?.title || 'Vehicle listing', id: complaint.vehicle?.id || '', price: complaint.vehicle?.price ? `${complaint.vehicle.price} MAD` : 'Price on request' },
//     evidence: (complaint.attachments || []).filter((item: any) => item.UploaderRole === 'buyer').map((item: any) => ({ id: item.id, name: item.OriginalName, type: item.MimeType === 'application/pdf' ? 'pdf' : 'image', size: `${Math.max(1, Math.round(item.FileSize / 1024))} KB` })),
//     timeline: (complaint.activities || []).filter((item: any) => item.Event !== 'Seller response submitted').map((item: any) => ({ event: item.Event, date: new Date(item.CreatedOn).toLocaleString(), actor: item.ActorRole === 'seller' ? 'You (Seller)' : item.ActorRole, role: item.ActorRole || 'system', note: item.Note || '' })),
//   };
//   const status = STATUS_CONFIG[c?.status || 'submitted'];

//   const handleSend = async () => {
//     if (!response.trim()) { setResponseError('Response is required'); return; }
//     setResponseError('');
//     setSending(true);
//     try { await submitComplaintResponse(id!, response); if (selectedFiles.length) await uploadComplaintAttachments(id!, selectedFiles); } catch (error: any) { setResponseError(error.response?.data?.message || 'Unable to submit response'); setSending(false); return; }
//     setResponses(prev => [...prev, { text: response, date: 'Just now' }]);
//     setResponse('');
//     setSelectedFiles([]);
//     setSending(false);
//     setSent(true);
//   };

// if (loading) {
//   return <SellerComplaintDetailSkeleton />;
// }
//   if (!c || loadError) return <div className="p-4 md:p-8"><div className="rounded-2xl border border-[#EF4444]/30 bg-[#EF4444]/5 p-6 text-center text-sm text-[#EF4444]">{loadError || 'Complaint not found'}</div></div>;

//   return (
//     <div className="p-4 md:p-8 max-w-5xl">
//       {/* Header */}
//       <div className="flex items-center gap-3 mb-6">
//         <button onClick={() => navigate(complaintBasePath)} className="p-2 hover:bg-[#F5F7FA] rounded-xl text-[#717182] transition-colors">
//           <ArrowLeft className="w-5 h-5" />
//         </button>
//         <div className="flex-1">
//           <div className="flex flex-wrap items-center gap-3">
//             <h1 className="text-xl text-[#2D323A]">Complaint #{c.id}</h1>
//             <span className={`inline-flex items-center gap-1.5 px-3 py-1 rounded-full text-xs ${status.bg} ${status.color}`}>
//               {status.label}
//             </span>
//             {c.status === 'awaiting_response' && (
//               <span className="inline-flex items-center gap-1 px-2 py-0.5 bg-[#EF4444]/10 text-[#EF4444] rounded-full text-xs">
//                 <AlertTriangle className="w-3 h-3" /> Response Required
//               </span>
//             )}
//           </div>
//           <p className="text-sm text-[#717182] mt-0.5">{c.category} · Filed {c.date}</p>
//         </div>
//       </div>

//       <div className="grid grid-cols-1 lg:grid-cols-3 gap-6">
//         {/* Main */}
//         <div className="lg:col-span-2 space-y-5">
//           {/* Complaint Info */}
//           <div className="bg-white rounded-2xl border border-[#E5E7EB] p-6">
//             <h2 className="text-[#2D323A] mb-1">{c.subject}</h2>
//             <p className="text-sm text-[#717182] leading-relaxed">{c.description}</p>
//           </div>

//           {/* Buyer Evidence */}
//           <div className="bg-white rounded-2xl border border-[#E5E7EB] p-6">
//             <h2 className="text-[#2D323A] mb-4">Buyer's Submitted Evidence</h2>
//             <div className="space-y-2">
//               {c.evidence.map((e, i) => (
//                 <div key={i} className="flex items-center gap-3 p-3 bg-[#F5F7FA] rounded-xl border border-[#E5E7EB]">
//                   <div className={`w-9 h-9 rounded-lg flex items-center justify-center flex-shrink-0 ${e.type === 'pdf' ? 'bg-[#EF4444]/10' : 'bg-[#1E6DFF]/10'}`}>
//                     {e.type === 'pdf' ? <FileText className="w-5 h-5 text-[#EF4444]" /> : <ImageIcon className="w-5 h-5 text-[#1E6DFF]" />}
//                   </div>
//                   <div className="flex-1 min-w-0">
//                     <p className="text-sm text-[#2D323A] truncate">{e.name}</p>
//                     <p className="text-xs text-[#717182]">{e.size}</p>
//                   </div>
//                   <button onClick={async () => { const blob = await downloadComplaintAttachment(id!, e.id); const url = URL.createObjectURL(blob); const link = document.createElement('a'); link.href = url; link.download = e.name; link.click(); URL.revokeObjectURL(url); }} className="p-1.5 hover:bg-white rounded-lg text-[#717182] hover:text-[#1E6DFF] transition-colors">
//                     <Download className="w-4 h-4" />
//                   </button>
//                 </div>
//               ))}
//             </div>
//           </div>

//           {/* Timeline */}
//           <div className="bg-white rounded-2xl border border-[#E5E7EB] p-6">
//             <h2 className="text-[#2D323A] mb-5">Timeline</h2>
//             <div className="relative">
//               <div className="absolute left-4 top-0 bottom-0 w-0.5 bg-[#E5E7EB]" />
//               <div className="space-y-6">
//                 {c.timeline.map((t, i) => (
//                   <div key={i} className="relative pl-10">
//                     <div className={`absolute left-0 w-8 h-8 rounded-full flex items-center justify-center text-xs ${ROLE_STYLES[t.role]}`}>
//                       {t.role === 'buyer' ? <User className="w-4 h-4" /> : t.role === 'admin' ? <Shield className="w-4 h-4" /> : <Clock className="w-4 h-4" />}
//                     </div>
//                     <div className="bg-[#F5F7FA] rounded-xl p-3.5 border border-[#E5E7EB]">
//                       <div className="flex items-center justify-between mb-1">
//                         <span className="text-sm text-[#2D323A]">{t.event}</span>
//                         <span className={`text-xs px-2 py-0.5 rounded-full ${ROLE_STYLES[t.role]}`}>{t.actor}</span>
//                       </div>
//                       <p className="text-xs text-[#717182] mb-1">{t.date}</p>
//                       <p className="text-sm text-[#717182]">{t.note}</p>
//                     </div>
//                   </div>
//                 ))}
//                 {responses.map((r, i) => (
//                   <div key={`resp-${i}`} className="relative pl-10">
//                     <div className="absolute left-0 w-8 h-8 rounded-full flex items-center justify-center text-xs bg-[#22C55E]/10 text-[#22C55E]">
//                       <User className="w-4 h-4" />
//                     </div>
//                     <div className="bg-[#22C55E]/5 rounded-xl p-3.5 border border-[#22C55E]/20">
//                       <div className="flex items-center justify-between mb-1">
//                         <span className="text-sm text-[#2D323A]">You responded</span>
//                         <span className="text-xs px-2 py-0.5 rounded-full bg-[#22C55E]/10 text-[#22C55E]">You (Seller)</span>
//                       </div>
//                       <p className="text-xs text-[#717182] mb-1">{r.date}</p>
//                       <p className="text-sm text-[#717182]">{r.text}</p>
//                     </div>
//                   </div>
//                 ))}
//               </div>
//             </div>
//           </div>

//           {/* Response Form */}
//           <div className="bg-white rounded-2xl border border-[#E5E7EB] p-6">
//             <h2 className="text-[#2D323A] mb-1">Respond to Complaint</h2>
//             <p className="text-sm text-[#717182] mb-4">Your response will be reviewed by MORROCARS and shared with the buyer.</p>

//             {sent && (
//               <div className="flex items-center gap-2 bg-[#22C55E]/10 border border-[#22C55E]/20 rounded-xl px-4 py-3 mb-4">
//                 <CheckCircle className="w-4 h-4 text-[#22C55E]" />
//                 <p className="text-sm text-[#22C55E]">Response submitted successfully.</p>
//               </div>
//             )}

//             <textarea
//               value={response}
//               onChange={e => { setResponse(e.target.value); setResponseError(''); }}
//               rows={5}
//               placeholder="Provide your detailed response to this complaint. Explain the vehicle's condition, any discrepancies, and your position..."
//               className={`w-full px-4 py-3 bg-[#F5F7FA] border rounded-xl focus:outline-none focus:border-[#1E6DFF] transition-colors resize-none text-sm mb-2 ${responseError ? 'border-[#EF4444]' : 'border-[#E5E7EB]'}`}
//             />
//             {responseError && <p className="flex items-center gap-1 text-[#EF4444] text-xs mb-3"><AlertCircle className="w-3 h-3" /> {responseError}</p>}

//             <div className="flex flex-col sm:flex-row items-stretch sm:items-center gap-3">
//               <label className="flex items-center justify-center gap-2 px-4 py-2.5 border border-[#E5E7EB] text-[#2D323A] rounded-xl hover:border-[#1E6DFF] transition-colors text-sm cursor-pointer"><Paperclip className="w-4 h-4" /> {selectedFiles.length ? `${selectedFiles.length} file(s) selected` : 'Attach Supporting Docs'}<input type="file" accept="image/*,.pdf" multiple className="hidden" onChange={event => setSelectedFiles(Array.from(event.target.files || []).slice(0, 5))} /></label>
//               <button
//                 onClick={handleSend}
//                 disabled={sending}
//                 className="flex-1 sm:flex-none flex items-center justify-center gap-2 px-6 py-2.5 bg-[#1E6DFF] text-white rounded-xl hover:bg-[#1557d9] transition-colors text-sm disabled:opacity-60"
//               >
//                 {sending ? 'Sending...' : <><Send className="w-4 h-4" /> Submit Response</>}
//               </button>
//             </div>
//             {selectedFiles.length > 0 && <div className="mt-3 space-y-2">{selectedFiles.map((file, index) => <div key={`${file.name}-${index}`} className="flex items-center justify-between rounded-lg bg-[#F5F7FA] px-3 py-2 text-xs text-[#717182]"><span className="truncate pr-3">{file.name} ({Math.ceil(file.size / 1024)} KB)</span><button type="button" onClick={() => setSelectedFiles(files => files.filter((_, fileIndex) => fileIndex !== index))} className="text-[#EF4444] hover:underline">Remove</button></div>)}</div>}
//           </div>
//         </div>

//         {/* Sidebar */}
//         <div className="space-y-5">
//           {/* Buyer Info */}
//           <div className="bg-white rounded-2xl border border-[#E5E7EB] p-5">
//             <h3 className="text-sm text-[#717182] mb-3">Buyer Information</h3>
//             <div className="flex items-center gap-3 mb-3">
//               <div className="w-10 h-10 bg-[#1E6DFF]/10 rounded-full flex items-center justify-center">
//                 <User className="w-5 h-5 text-[#1E6DFF]" />
//               </div>
//               <div>
//                 <p className="text-sm text-[#2D323A]">{c.buyer.name}</p>
//                 <p className="text-xs text-[#717182]">Member since {c.buyer.joined}</p>
//               </div>
//             </div>
//             {c.buyer.verified && (
//               <span className="inline-flex items-center gap-1 text-xs text-[#22C55E] bg-[#22C55E]/10 px-2 py-0.5 rounded-full">
//                 <CheckCircle className="w-3 h-3" /> Verified Buyer
//               </span>
//             )}
//             <button className="flex items-center gap-2 w-full mt-3 px-4 py-2 border border-[#E5E7EB] text-[#2D323A] rounded-xl hover:border-[#1E6DFF] hover:text-[#1E6DFF] transition-colors text-sm">
//               <MessageSquare className="w-4 h-4" /> Message Buyer
//             </button>
//           </div>

//           {/* Vehicle Info */}
//           <div className="bg-white rounded-2xl border border-[#E5E7EB] p-5">
//             <h3 className="text-sm text-[#717182] mb-3">Affected Listing</h3>
//             <div className="flex items-start gap-3">
//               <div className="w-14 h-10 bg-[#F5F7FA] rounded-lg flex items-center justify-center flex-shrink-0 border border-[#E5E7EB]">
//                 <span className="text-xl">🚗</span>
//               </div>
//               <div>
//                 <p className="text-sm text-[#2D323A]">{c.vehicle.title}</p>
//                 <p className="text-xs text-[#717182]">#{c.vehicle.id}</p>
//                 <p className="text-sm text-[#1E6DFF] mt-0.5">{c.vehicle.price}</p>
//               </div>
//             </div>
//             <Link to={`/vehicle/${c.vehicle.id}`} className="flex items-center gap-1 text-xs text-[#1E6DFF] hover:underline mt-3">
//               <ExternalLink className="w-3 h-3" /> View Listing
//             </Link>
//           </div>

//           {/* Actions */}
//           <div className="bg-white rounded-2xl border border-[#E5E7EB] p-5 space-y-2">
//             <h3 className="text-sm text-[#717182] mb-3">Actions</h3>
//             <label className="w-full flex items-center gap-2 px-4 py-2.5 border border-[#E5E7EB] text-[#2D323A] rounded-xl hover:border-[#1E6DFF] hover:text-[#1E6DFF] transition-colors text-sm cursor-pointer"><Upload className="w-4 h-4" /> Upload with your response<input type="file" accept="image/*,.pdf" multiple className="hidden" onChange={event => setSelectedFiles(Array.from(event.target.files || []).slice(0, 5))} /></label>
//             <button className="w-full flex items-center gap-2 px-4 py-2.5 border border-[#E5E7EB] text-[#2D323A] rounded-xl hover:border-[#1E6DFF] hover:text-[#1E6DFF] transition-colors text-sm">
//               <Download className="w-4 h-4" /> Download Evidence
//             </button>
//             <button
//               onClick={() => setShowEscalateModal(true)}
//               disabled={c.escalated}
//               className="w-full flex items-center gap-2 px-4 py-2.5 bg-[#8B5CF6]/10 text-[#8B5CF6] rounded-xl hover:bg-[#8B5CF6]/20 transition-colors text-sm disabled:cursor-not-allowed disabled:opacity-50"
//             >
//               <Shield className="w-4 h-4" /> {c.escalated ? 'Admin Review Requested' : 'Request Admin Review'}
//             </button>
//           </div>
//         </div>
//       </div>

//       {/* Escalate Modal */}
//       {showEscalateModal && (
//         <div className="fixed inset-0 bg-black/50 z-50 flex items-center justify-center p-4">
//           <div className="bg-white rounded-2xl p-6 max-w-sm w-full shadow-2xl">
//             <div className="flex items-center justify-between mb-4">
//               <h3 className="text-[#2D323A]">Request Admin Review</h3>
//               <button onClick={() => setShowEscalateModal(false)}><X className="w-5 h-5 text-[#717182]" /></button>
//             </div>
//             <p className="text-sm text-[#717182] mb-5">Our admin team will manually review this complaint and mediate between both parties. This may take 3–5 business days.</p>
//             <textarea value={reviewNote} onChange={event => setReviewNote(event.target.value)} rows={3} placeholder="Additional notes for admin team..." className="w-full px-4 py-3 bg-[#F5F7FA] border border-[#E5E7EB] rounded-xl focus:outline-none focus:border-[#1E6DFF] text-sm mb-4 resize-none" />
//             <div className="flex gap-3">
//               <button onClick={() => setShowEscalateModal(false)} className="flex-1 py-2.5 border border-[#E5E7EB] rounded-xl text-[#2D323A] text-sm hover:border-[#1E6DFF] transition-colors">Cancel</button>
//               <button onClick={async () => { try { await requestComplaintReview(id!, reviewNote); await loadComplaint(); setShowEscalateModal(false); } catch (error: any) { setResponseError(error.response?.data?.message || 'Unable to request admin review'); } }} className="flex-1 py-2.5 bg-[#8B5CF6] text-white rounded-xl text-sm hover:bg-[#7c3aed] transition-colors">Submit Request</button>
//             </div>
//           </div>
//         </div>
//       )}
//     </div>
//   );
// }
// src/components/sellerComplaint/SellerComplaintDetail.tsx
import { useState, useEffect } from "react";
import { useParams, useNavigate, Link } from 'react-router';
import { useTranslation } from 'react-i18next';
import Cookies from 'js-cookie';
import { downloadComplaintAttachment, getSellerComplaint, requestComplaintReview, submitComplaintResponse, uploadComplaintAttachments } from '../../../services/customerComplaint.service';
import { useMessaging } from '../../../contexts/MessagingContext';
import {
  ArrowLeft, Clock, CheckCircle, XCircle, AlertCircle, MessageSquare,
  Upload, Download, FileText, Image as ImageIcon, Send, Paperclip,
  User, Shield, Phone, X, ExternalLink, AlertTriangle, Trash2
} from 'lucide-react';

// ----- Status Config (labels will be translated) -----
const getStatusConfig = (t: any) => ({
  submitted: { label: t('sellerComplaintDetail.status_submitted'), color: 'text-[#1E6DFF]', bg: 'bg-[#1E6DFF]/10' },
  under_review: { label: t('sellerComplaintDetail.status_under_review'), color: 'text-[#F59E0B]', bg: 'bg-[#F59E0B]/10' },
  awaiting_response: { label: t('sellerComplaintDetail.status_awaiting_response_label'), color: 'text-[#8B5CF6]', bg: 'bg-[#8B5CF6]/10' },
  resolved: { label: t('sellerComplaintDetail.status_resolved'), color: 'text-[#22C55E]', bg: 'bg-[#22C55E]/10' },
  rejected: { label: t('sellerComplaintDetail.status_rejected'), color: 'text-[#EF4444]', bg: 'bg-[#EF4444]/10' },
  closed: { label: t('sellerComplaintDetail.status_closed'), color: 'text-[#717182]', bg: 'bg-[#717182]/10' },
});

function SellerComplaintDetailSkeleton() {
  return (
    <div className="p-4 md:p-8 max-w-5xl">
      {/* Header */}
      <div className="flex items-center gap-3 mb-6">
        <Skeleton className="w-10 h-10 rounded-xl" />

        <div className="flex-1 space-y-3">
          <Skeleton className="h-7 w-64" />
          <Skeleton className="h-4 w-40" />
        </div>

        <Skeleton className="w-28 h-8 rounded-full" />
      </div>

      <div className="grid grid-cols-1 lg:grid-cols-3 gap-6">
        {/* Left */}
        <div className="lg:col-span-2 space-y-5">

          {/* Complaint */}
          <div className="bg-white rounded-2xl border border-[#E5E7EB] p-6">
            <Skeleton className="h-6 w-72 mb-4" />
            <Skeleton className="h-4 w-full mb-2" />
            <Skeleton className="h-4 w-full mb-2" />
            <Skeleton className="h-4 w-5/6" />
          </div>

          {/* Evidence */}
          <div className="bg-white rounded-2xl border border-[#E5E7EB] p-6">
            <Skeleton className="h-6 w-48 mb-5" />

            {[1,2,3].map((i)=>(
              <div key={i} className="flex items-center gap-3 mb-3">
                <Skeleton className="w-10 h-10 rounded-lg" />

                <div className="flex-1">
                  <Skeleton className="h-4 w-48 mb-2" />
                  <Skeleton className="h-3 w-20" />
                </div>

                <Skeleton className="w-8 h-8 rounded-lg" />
              </div>
            ))}
          </div>

          {/* Timeline */}
          <div className="bg-white rounded-2xl border border-[#E5E7EB] p-6">
            <Skeleton className="h-6 w-36 mb-5" />

            {[1,2,3].map((i)=>(
              <div key={i} className="flex gap-3 mb-6">
                <Skeleton className="w-8 h-8 rounded-full" />

                <div className="flex-1">
                  <Skeleton className="h-24 rounded-xl w-full" />
                </div>
              </div>
            ))}
          </div>

          {/* Response */}
          <div className="bg-white rounded-2xl border border-[#E5E7EB] p-6">
            <Skeleton className="h-6 w-52 mb-2" />
            <Skeleton className="h-4 w-80 mb-5" />

            <Skeleton className="h-36 rounded-xl mb-4" />

            <div className="flex gap-3">
              <Skeleton className="h-11 w-44 rounded-xl" />
              <Skeleton className="h-11 w-40 rounded-xl" />
            </div>
          </div>
        </div>

        {/* Right Sidebar */}
        <div className="space-y-5">

          {[1,2,3].map((card)=>(
            <div
              key={card}
              className="bg-white rounded-2xl border border-[#E5E7EB] p-5"
            >
              <Skeleton className="h-5 w-32 mb-4" />

              <Skeleton className="w-12 h-12 rounded-full mb-4" />

              <Skeleton className="h-4 w-40 mb-2" />
              <Skeleton className="h-4 w-28 mb-5" />

              <Skeleton className="h-10 w-full rounded-xl" />
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}


const ROLE_STYLES: Record<string, string> = {
  buyer: 'bg-[#1E6DFF]/10 text-[#1E6DFF]',
  admin: 'bg-[#8B5CF6]/10 text-[#8B5CF6]',
  system: 'bg-[#717182]/10 text-[#717182]',
  seller: 'bg-[#22C55E]/10 text-[#22C55E]',
};

const formatDate = (value: string) => new Intl.DateTimeFormat('en-US', { month: 'short', day: 'numeric', year: 'numeric' }).format(new Date(value));

const Skeleton = ({ className = "" }: { className?: string }) => (
  <div className={`animate-pulse rounded-lg bg-gray-200 ${className}`} />
);

export function SellerComplaintDetail() {
  const { t } = useTranslation('auth');
  const { id } = useParams();
  const navigate = useNavigate();
  const { sendMessage } = useMessaging();
  const [complaint, setComplaint] = useState<any>(null);
  const [response, setResponse] = useState('');
  const [responseError, setResponseError] = useState('');
  const [sending, setSending] = useState(false);
  const [sent, setSent] = useState(false);
  const [responses, setResponses] = useState<{ text: string; date: string }[]>([]);
  const [showEscalateModal, setShowEscalateModal] = useState(false);
  const [loading, setLoading] = useState(true);
  const [loadError, setLoadError] = useState('');
  const [reviewNote, setReviewNote] = useState('');
  const [selectedFiles, setSelectedFiles] = useState<File[]>([]);
  const [showMessageModal, setShowMessageModal] = useState(false);
  const [buyerMessage, setBuyerMessage] = useState('');
  const [messageError, setMessageError] = useState('');
  const [messageSending, setMessageSending] = useState(false);
  const complaintBasePath = Number(Cookies.get('customerType')) === 3 ? '/dealer/complaints' : '/dashboard/complaints';
  const statusConfig = getStatusConfig(t);

  const loadComplaint = async () => {
    if (!id) return;
    try {
      setLoadError('');
      const data = await getSellerComplaint(id);
      setComplaint(data);
      setResponses((data.comments || data.responses || [])
        .filter((item: any) => item.UserRole === 'seller')
        .map((item: any) => ({
          text: item.Text || item.Message,
          date: new Date(item.CreatedAt || item.CreatedOn).toLocaleString(),
        })));
    } catch (error: any) { setLoadError(error.response?.data?.message || t('sellerComplaintDetail.load_error')); }
    finally { setLoading(false); }
  };

  useEffect(() => { void loadComplaint(); }, [id]);

  const c = complaint && {
    id: complaint.ReferenceNumber || complaint.id, date: formatDate(complaint.CreatedOn), status: complaint.Status,
    category: complaint.Category, subject: complaint.Subject, description: complaint.Description, escalated: Boolean(complaint.EscalatedOn),
    buyer: { name: complaint.buyer?.name || 'Buyer', id: complaint.buyer?.id || '', joined: complaint.buyer?.joined ? new Date(complaint.buyer.joined).toLocaleDateString() : '', verified: complaint.buyer?.verified },
    vehicle: {
      title: complaint.vehicle?.title || 'Vehicle listing',
      id: complaint.vehicle?.id || '',
      price: complaint.vehicle?.price ? `${Number(complaint.vehicle.price).toLocaleString()} MAD` : 'Price on request',
      images: complaint.vehicle?.images || [],
    },
    evidence: (complaint.evidence || complaint.attachments || []).map((item: any) => ({
      id: item.id,
      name: item.FileName || item.OriginalName,
      type: item.MimeType === 'application/pdf' ? 'pdf' : 'image',
      size: `${Math.max(1, Math.round((item.Size || item.FileSize || 0) / 1024))} KB`,
    })),
    timeline: (complaint.timeline || complaint.activities || [])
      .filter((item: any) => item.Event !== 'Seller response submitted')
      .map((item: any) => {
        const role = item.Role || item.ActorRole || 'system';
        return {
          event: item.Event,
          date: new Date(item.CreatedAt || item.CreatedOn).toLocaleString(),
          actor: role === 'seller' ? 'You (Seller)' : role,
          role,
          note: item.Note || '',
        };
      }),
  };

  const status = statusConfig[(c?.status as keyof typeof statusConfig) || 'submitted'];

  const handleSend = async () => {
    if (!response.trim()) {
      setResponseError(t('sellerComplaintDetail.response_required'));
      return;
    }
    setResponseError('');
    setSending(true);
    try {
      await submitComplaintResponse(id!, response);
      if (selectedFiles.length) await uploadComplaintAttachments(id!, selectedFiles);
    } catch (error: any) {
      setResponseError(error.response?.data?.message || t('sellerComplaintDetail.load_error'));
      setSending(false);
      return;
    }
    setResponses(prev => [...prev, { text: response, date: t('sellerComplaintDetail.you_responded') + ' - ' + new Date().toLocaleString() }]);
    setResponse('');
    setSelectedFiles([]);
    setSending(false);
    setSent(true);
  };

  const handleMessageBuyer = async () => {
    if (!buyerMessage.trim()) {
      setMessageError('Message is required');
      return;
    }

    if (!c?.vehicle.id || !c.buyer.id) {
      setMessageError('Buyer or vehicle information is unavailable');
      return;
    }

    setMessageSending(true);
    setMessageError('');

    try {
      await sendMessage({
        vehicleId: c.vehicle.id,
        receiverId: c.buyer.id,
        text: buyerMessage.trim(),
      });
      setBuyerMessage('');
      setShowMessageModal(false);
    } catch (error: any) {
      setMessageError(error.message || 'Unable to send message');
    } finally {
      setMessageSending(false);
    }
  };

if (loading) {
  return <SellerComplaintDetailSkeleton />;
}
  if (!c || loadError) return <div className="p-4 md:p-8"><div className="rounded-2xl border border-[#EF4444]/30 bg-[#EF4444]/5 p-6 text-center text-sm text-[#EF4444]">{loadError || 'Complaint not found'}</div></div>;

  return (
    <div className="p-4 md:p-8 max-w-5xl">
      {/* Header */}
      <div className="flex items-center gap-3 mb-6">
        <button onClick={() => navigate(complaintBasePath)} className="p-2 hover:bg-[#F5F7FA] rounded-xl text-[#717182] transition-colors">
          <ArrowLeft className="w-5 h-5" />
        </button>
        <div className="flex-1">
          <div className="flex flex-wrap items-center gap-3">
            <h1 className="text-xl text-[#2D323A]">{t('sellerComplaintDetail.title')} #{c.id}</h1>
            <span className={`inline-flex items-center gap-1.5 px-3 py-1 rounded-full text-xs ${status.bg} ${status.color}`}>
              {status.label}
            </span>
            {c.status === 'awaiting_response' && (
              <span className="inline-flex items-center gap-1 px-2 py-0.5 bg-[#EF4444]/10 text-[#EF4444] rounded-full text-xs">
                <AlertTriangle className="w-3 h-3" /> {t('sellerComplaintDetail.status_awaiting_response')}
              </span>
            )}
          </div>
          <p className="text-sm text-[#717182] mt-0.5">{c.category} · {t('sellerComplaintDetail.filed')} {c.date}</p>
        </div>
      </div>

      <div className="grid grid-cols-1 lg:grid-cols-3 gap-6">
        {/* Main */}
        <div className="lg:col-span-2 space-y-5">
          {/* Complaint Info */}
          <div className="bg-white rounded-2xl border border-[#E5E7EB] p-6">
            <h2 className="text-[#2D323A] mb-1">{c.subject}</h2>
            <p className="text-sm text-[#717182] leading-relaxed">{c.description}</p>
          </div>

          {/* Buyer Evidence */}
          <div className="bg-white rounded-2xl border border-[#E5E7EB] p-6">
            <h2 className="text-[#2D323A] mb-4">{t('sellerComplaintDetail.buyer_evidence')}</h2>
            <div className="space-y-2">
              {c.evidence.map((e, i) => (
                <div key={i} className="flex items-center gap-3 p-3 bg-[#F5F7FA] rounded-xl border border-[#E5E7EB]">
                  <div className={`w-9 h-9 rounded-lg flex items-center justify-center flex-shrink-0 ${e.type === 'pdf' ? 'bg-[#EF4444]/10' : 'bg-[#1E6DFF]/10'}`}>
                    {e.type === 'pdf' ? <FileText className="w-5 h-5 text-[#EF4444]" /> : <ImageIcon className="w-5 h-5 text-[#1E6DFF]" />}
                  </div>
                  <div className="flex-1 min-w-0">
                    <p className="text-sm text-[#2D323A] truncate">{e.name}</p>
                    <p className="text-xs text-[#717182]">{e.size}</p>
                  </div>
                  <button
                    onClick={async () => {
                      const blob = await downloadComplaintAttachment(id!, e.id);
                      const url = URL.createObjectURL(blob);
                      const link = document.createElement('a');
                      link.href = url;
                      link.download = e.name;
                      link.click();
                      URL.revokeObjectURL(url);
                    }}
                    className="p-1.5 hover:bg-white rounded-lg text-[#717182] hover:text-[#1E6DFF] transition-colors"
                  >
                    <Download className="w-4 h-4" />
                  </button>
                </div>
              ))}
            </div>
          </div>

          {/* Timeline */}
          <div className="bg-white rounded-2xl border border-[#E5E7EB] p-6">
            <h2 className="text-[#2D323A] mb-5">{t('sellerComplaintDetail.timeline')}</h2>
            <div className="relative">
              <div className="absolute left-4 top-0 bottom-0 w-0.5 bg-[#E5E7EB]" />
              <div className="space-y-6">
                {c.timeline.map((t, i) => (
                  <div key={i} className="relative pl-10">
                    <div className={`absolute left-0 w-8 h-8 rounded-full flex items-center justify-center text-xs ${ROLE_STYLES[t.role]}`}>
                      {t.role === 'buyer' ? <User className="w-4 h-4" /> : t.role === 'admin' ? <Shield className="w-4 h-4" /> : <Clock className="w-4 h-4" />}
                    </div>
                    <div className="bg-[#F5F7FA] rounded-xl p-3.5 border border-[#E5E7EB]">
                      <div className="flex items-center justify-between mb-1">
                        <span className="text-sm text-[#2D323A]">{t.event}</span>
                        <span className={`text-xs px-2 py-0.5 rounded-full ${ROLE_STYLES[t.role]}`}>{t.actor}</span>
                      </div>
                      <p className="text-xs text-[#717182] mb-1">{t.date}</p>
                      <p className="text-sm text-[#717182]">{t.note}</p>
                    </div>
                  </div>
                ))}
                {responses.map((r, i) => (
                  <div key={`resp-${i}`} className="relative pl-10">
                    <div className="absolute left-0 w-8 h-8 rounded-full flex items-center justify-center text-xs bg-[#22C55E]/10 text-[#22C55E]">
                      <User className="w-4 h-4" />
                    </div>
                    <div className="bg-[#22C55E]/5 rounded-xl p-3.5 border border-[#22C55E]/20">
                      <div className="flex items-center justify-between mb-1">
                        <span className="text-sm text-[#2D323A]">{t('sellerComplaintDetail.you_responded')}</span>
                        <span className="text-xs px-2 py-0.5 rounded-full bg-[#22C55E]/10 text-[#22C55E]">{t('sellerComplaintDetail.actor_you')}</span>
                      </div>
                      <p className="text-xs text-[#717182] mb-1">{r.date}</p>
                      <p className="text-sm text-[#717182]">{r.text}</p>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>

          {/* Response Form */}
          <div className="bg-white rounded-2xl border border-[#E5E7EB] p-6">
            <h2 className="text-[#2D323A] mb-1">{t('sellerComplaintDetail.respond_title')}</h2>
            <p className="text-sm text-[#717182] mb-4">{t('sellerComplaintDetail.respond_description')}</p>

            {sent && (
              <div className="flex items-center gap-2 bg-[#22C55E]/10 border border-[#22C55E]/20 rounded-xl px-4 py-3 mb-4">
                <CheckCircle className="w-4 h-4 text-[#22C55E]" />
                <p className="text-sm text-[#22C55E]">{t('sellerComplaintDetail.response_success')}</p>
              </div>
            )}

            <textarea
              value={response}
              onChange={e => { setResponse(e.target.value); setResponseError(''); }}
              rows={5}
              placeholder={t('sellerComplaintDetail.response_placeholder')}
              className={`w-full px-4 py-3 bg-[#F5F7FA] border rounded-xl focus:outline-none focus:border-[#1E6DFF] transition-colors resize-none text-sm mb-2 ${responseError ? 'border-[#EF4444]' : 'border-[#E5E7EB]'}`}
            />
            {responseError && <p className="flex items-center gap-1 text-[#EF4444] text-xs mb-3"><AlertCircle className="w-3 h-3" /> {responseError}</p>}

            <div className="flex flex-col sm:flex-row items-stretch sm:items-center gap-3">
              <label className="flex items-center justify-center gap-2 px-4 py-2.5 border border-[#E5E7EB] text-[#2D323A] rounded-xl hover:border-[#1E6DFF] transition-colors text-sm cursor-pointer">
                <Paperclip className="w-4 h-4" />
                {selectedFiles.length
                  ? t('sellerComplaintDetail.attach_files', { count: selectedFiles.length })
                  : t('sellerComplaintDetail.attach_docs')
                }
                <input
                  type="file"
                  accept="image/*,.pdf"
                  multiple
                  className="hidden"
                  onChange={event => setSelectedFiles(Array.from(event.target.files || []).slice(0, 5))}
                />
              </label>
              <button
                onClick={handleSend}
                disabled={sending}
                className="flex-1 sm:flex-none flex items-center justify-center gap-2 px-6 py-2.5 bg-[#1E6DFF] text-white rounded-xl hover:bg-[#1557d9] transition-colors text-sm disabled:opacity-60"
              >
                {sending ? t('sellerComplaintDetail.sending') : <><Send className="w-4 h-4" /> {t('sellerComplaintDetail.submit_response')}</>}
              </button>
            </div>
            {selectedFiles.length > 0 && (
              <div className="mt-3 space-y-2">
                {selectedFiles.map((file, index) => (
                  <div key={`${file.name}-${index}`} className="flex items-center justify-between rounded-lg bg-[#F5F7FA] px-3 py-2 text-xs text-[#717182]">
                    <span className="truncate pr-3">{file.name} ({Math.ceil(file.size / 1024)} KB)</span>
                    <button
                      type="button"
                      onClick={() => setSelectedFiles(files => files.filter((_, fileIndex) => fileIndex !== index))}
                      className="p-1 text-[#EF4444] hover:text-red-700 hover:bg-red-50 rounded-lg transition-colors"
                      title={t('sellerComplaintDetail.remove_file')}
                      aria-label={t('sellerComplaintDetail.remove_file')}
                    >
                      <Trash2 className="w-4 h-4" />
                    </button>
                  </div>
                ))}
              </div>
            )}
          </div>
        </div>

        {/* Sidebar */}
        <div className="space-y-5">
          {/* Buyer Info */}
          <div className="bg-white rounded-2xl border border-[#E5E7EB] p-5">
            <h3 className="text-sm text-[#717182] mb-3">{t('sellerComplaintDetail.buyer_info')}</h3>
            <div className="flex items-center gap-3 mb-3">
              <div className="w-10 h-10 bg-[#1E6DFF]/10 rounded-full flex items-center justify-center">
                <User className="w-5 h-5 text-[#1E6DFF]" />
              </div>
              <div>
                <p className="text-sm text-[#2D323A]">{c.buyer.name}</p>
                <p className="text-xs text-[#717182]">{t('sellerComplaintDetail.member_since')} {c.buyer.joined}</p>
              </div>
            </div>
            {c.buyer.verified && (
              <span className="inline-flex items-center gap-1 text-xs text-[#22C55E] bg-[#22C55E]/10 px-2 py-0.5 rounded-full">
                <CheckCircle className="w-3 h-3" /> {t('sellerComplaintDetail.verified_buyer')}
              </span>
            )}
            <button onClick={() => { setMessageError(''); setShowMessageModal(true); }} className="flex items-center gap-2 w-full mt-3 px-4 py-2 border border-[#E5E7EB] text-[#2D323A] rounded-xl hover:border-[#1E6DFF] hover:text-[#1E6DFF] transition-colors text-sm">
              <MessageSquare className="w-4 h-4" /> {t('sellerComplaintDetail.message_buyer')}
            </button>
          </div>

          {/* Vehicle Info */}
          <div className="bg-white rounded-2xl border border-[#E5E7EB] p-5">
            <h3 className="text-sm text-[#717182] mb-3">{t('sellerComplaintDetail.affected_listing')}</h3>
            <div className="flex items-start gap-3">
              {c.vehicle.images[0] && (
                <img
                  src={c.vehicle.images[0]}
                  alt={c.vehicle.title}
className="w-20 h-12 rounded-lg object-cover flex-shrink-0 border border-[#E5E7EB]"                />
              )}
              <div className={`${c.vehicle.images[0] ? 'hidden' : 'w-14 h-10 bg-[#F5F7FA] rounded-lg flex items-center justify-center flex-shrink-0 border border-[#E5E7EB]'}`}>
                <span className="text-xl">🚗</span>
              </div>
              <div>
                <p className="text-sm text-[#2D323A]">{c.vehicle.title}</p>
                {/* <p className="text-xs text-[#717182]">#{c.vehicle.id}</p> */}
                <p className="text-sm text-[#1E6DFF] mt-0.5">{c.vehicle.price}</p>
              </div>
            </div>
            <Link to={`/vehicle/${c.vehicle.id}`} className="flex items-center gap-1 text-xs text-[#1E6DFF] hover:underline mt-3">
              <ExternalLink className="w-3 h-3" /> {t('sellerComplaintDetail.view_listing')}
            </Link>
          </div>

          {/* Actions */}
          <div className="bg-white rounded-2xl border border-[#E5E7EB] p-5 space-y-2">
            <h3 className="text-sm text-[#717182] mb-3">{t('sellerComplaintDetail.actions')}</h3>
            <label className="w-full flex items-center gap-2 px-4 py-2.5 border border-[#E5E7EB] text-[#2D323A] rounded-xl hover:border-[#1E6DFF] hover:text-[#1E6DFF] transition-colors text-sm cursor-pointer">
              <Upload className="w-4 h-4" /> {t('sellerComplaintDetail.upload_with_response')}
              <input
                type="file"
                accept="image/*,.pdf"
                multiple
                className="hidden"
                onChange={event => setSelectedFiles(Array.from(event.target.files || []).slice(0, 5))}
              />
            </label>
            <button className="w-full flex items-center gap-2 px-4 py-2.5 border border-[#E5E7EB] text-[#2D323A] rounded-xl hover:border-[#1E6DFF] hover:text-[#1E6DFF] transition-colors text-sm">
              <Download className="w-4 h-4" /> {t('sellerComplaintDetail.download_evidence')}
            </button>
            <button
              onClick={() => setShowEscalateModal(true)}
              disabled={c.escalated}
              className="w-full flex items-center gap-2 px-4 py-2.5 bg-[#8B5CF6]/10 text-[#8B5CF6] rounded-xl hover:bg-[#8B5CF6]/20 transition-colors text-sm disabled:cursor-not-allowed disabled:opacity-50"
            >
              <Shield className="w-4 h-4" />
              {c.escalated
                ? t('sellerComplaintDetail.admin_review_requested')
                : t('sellerComplaintDetail.request_admin_review')
              }
            </button>
          </div>
        </div>
      </div>

      {/* Escalate Modal */}
      {showEscalateModal && (
        <div className="fixed inset-0 bg-black/50 z-50 flex items-center justify-center p-4">
          <div className="bg-white rounded-2xl p-6 max-w-sm w-full shadow-2xl">
            <div className="flex items-center justify-between mb-4">
              <h3 className="text-[#2D323A]">{t('sellerComplaintDetail.escalate_modal_title')}</h3>
              <button onClick={() => setShowEscalateModal(false)}><X className="w-5 h-5 text-[#717182]" /></button>
            </div>
            <p className="text-sm text-[#717182] mb-5">{t('sellerComplaintDetail.escalate_modal_desc')}</p>
            <textarea
              value={reviewNote}
              onChange={event => setReviewNote(event.target.value)}
              rows={3}
              placeholder={t('sellerComplaintDetail.escalate_modal_placeholder')}
              className="w-full px-4 py-3 bg-[#F5F7FA] border border-[#E5E7EB] rounded-xl focus:outline-none focus:border-[#1E6DFF] text-sm mb-4 resize-none"
            />
            <div className="flex gap-3">
              <button onClick={() => setShowEscalateModal(false)} className="flex-1 py-2.5 border border-[#E5E7EB] rounded-xl text-[#2D323A] text-sm hover:border-[#1E6DFF] transition-colors">
                {t('sellerComplaintDetail.escalate_modal_cancel')}
              </button>
              <button
                onClick={async () => {
                  try {
                    await requestComplaintReview(id!, reviewNote);
                    await loadComplaint();
                    setShowEscalateModal(false);
                  } catch (error: any) {
                    setResponseError(error.response?.data?.message || t('sellerComplaintDetail.load_error'));
                  }
                }}
                className="flex-1 py-2.5 bg-[#8B5CF6] text-white rounded-xl text-sm hover:bg-[#7c3aed] transition-colors"
              >
                {t('sellerComplaintDetail.escalate_modal_submit')}
              </button>
            </div>
          </div>
        </div>
      )}

      {showMessageModal && (
        <div className="fixed inset-0 bg-black/50 z-50 flex items-center justify-center p-4">
          <div className="bg-white rounded-2xl p-6 max-w-md w-full shadow-2xl">
            <div className="flex items-center justify-between mb-4">
              <div>
                <h3 className="text-[#2D323A]">Message Buyer</h3>
                <p className="text-xs text-[#717182] mt-1">This sends a private message to {c.buyer.name}.</p>
              </div>
              <button onClick={() => setShowMessageModal(false)} aria-label="Close message dialog"><X className="w-5 h-5 text-[#717182]" /></button>
            </div>
            <textarea
              value={buyerMessage}
              onChange={(event) => { setBuyerMessage(event.target.value); setMessageError(''); }}
              rows={5}
              placeholder="Write a private message to the buyer..."
              className={`w-full px-4 py-3 bg-[#F5F7FA] border rounded-xl focus:outline-none focus:border-[#1E6DFF] text-sm resize-none ${messageError ? 'border-[#EF4444]' : 'border-[#E5E7EB]'}`}
            />
            {messageError && <p className="text-[#EF4444] text-xs mt-2">{messageError}</p>}
            <div className="flex gap-3 mt-4">
              <button onClick={() => setShowMessageModal(false)} disabled={messageSending} className="flex-1 py-2.5 border border-[#E5E7EB] rounded-xl text-[#2D323A] text-sm hover:border-[#1E6DFF] transition-colors disabled:opacity-60">Cancel</button>
              <button onClick={handleMessageBuyer} disabled={messageSending} className="flex-1 flex items-center justify-center gap-2 py-2.5 bg-[#1E6DFF] text-white rounded-xl text-sm hover:bg-[#1557d9] transition-colors disabled:opacity-60">
                <Send className="w-4 h-4" /> {messageSending ? 'Sending...' : 'Send Message'}
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}